import {
  type GithubIntegrationEntry,
  githubIntegrationSchema,
} from "./GithubIntegrationForm.types";

export const emptyGithubIntegration = (): GithubIntegrationEntry =>
  githubIntegrationSchema.parse({});

export const isGithubUrl = (url: string) => url.trim().startsWith("https://");

export const canSaveGithub = (entry: GithubIntegrationEntry) =>
  !!entry.name.trim() &&
  isGithubUrl(entry.url) &&
  !!entry.personal_access_token.trim();
